module.exports = __webpack_public_path__ + "static/media/Gotham-Medium-Regular.97e8834b.otf";